import React, { useState, useEffect } from "react";
import { Divider } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { StyledSelect } from "../select2/StyledSelect.js";
import { TextFilter } from "./TextFilter.js";
const useClasses = makeStyles()((theme) => ({
  textWithDropdownFilter: {
    display: "flex",
    alignItems: "center",
    background: theme.palette.background.paper,
    borderRadius: theme.custom.defaultBorderRadius * 2,
    height: theme.custom.denseButtonHeight,
    "& .Mui-focused": {
      border: "0 !important",
      boxShadow: "none !important"
    },
    "& .MuiOutlinedInput-root": {
      border: "0 !important",
      boxShadow: "none !important"
    },
    border: "1px solid #E1E7EB",
    boxSizing: "border-box",
    boxShadow: `0px 1px 1px ${theme.custom.palette.content.boxShadow}`
  },
  textWithDropdownFilterWidthNoLimit: {
    display: "flex",
    flexGrow: 1
  },
  textWithDropdownFilterSelect: {
    paddingLeft: theme.spacing(2),
    paddingRight: `${theme.spacing(1.25)} !important`,
    "&:focus": {
      background: "transparent"
    }
  },
  textWithDropdownFilterSelectIcon: {
    paddingRight: theme.spacing(2)
  }
}));
function TextInputWithDropdownFilter({
  options,
  value,
  onChange,
  width,
  inputPlaceholder,
  getInputPlaceholder,
  disallowSpecialCharacters
}) {
  const { classes, cx } = useClasses();
  const [option, setOption] = useState(getOption());
  const [isDirty, setIsDirty] = useState(false);
  useEffect(() => {
    if (!isDirty) {
      setOption(getOption());
    }
  }, [value?.option, isDirty, options?.map((v) => v.value).join()]);
  function handleSelectChange(event) {
    onChange({ text: value?.text, option: event.target.value });
    setOption(event.target.value);
    setIsDirty(true);
  }
  function handleInputChange(newValue) {
    setIsDirty(true);
    onChange({ text: newValue, option });
  }
  function getOption() {
    return value?.option ?? options[0]?.value;
  }
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: cx(
        {
          [classes.textWithDropdownFilterWidthNoLimit]: width === "full"
        },
        classes.textWithDropdownFilter
      ),
      "data-testid": "dropdownTextFilter"
    },
    /* @__PURE__ */ React.createElement(
      StyledSelect,
      {
        disableUnderline: true,
        value: option,
        onChange: handleSelectChange,
        options,
        classes: { select: classes.textWithDropdownFilterSelect },
        iconClassName: classes.textWithDropdownFilterSelectIcon,
        alignLeft: true
      }
    ),
    /* @__PURE__ */ React.createElement(Divider, { orientation: "vertical" }),
    /* @__PURE__ */ React.createElement(
      TextFilter,
      {
        value: value?.text,
        width,
        inputPlaceholder: inputPlaceholder ?? getInputPlaceholder(option),
        onChange: handleInputChange,
        onEnter: handleInputChange,
        disallowSpecialCharacters
      }
    )
  );
}
export {
  TextInputWithDropdownFilter
};
//# sourceMappingURL=TextFilterWithDropdown.js.map
